module.exports = __webpack_public_path__ + "static/img/08.4381c12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/08.jpg
// module id = D6z8
// module chunks = 1